export default {
  name: '',
  email: '',
  subject: '',
  comments: '',
};
